import { configureStore } from "@reduxjs/toolkit";
import toastsReducer from "./slices/toast.slice";

export default configureStore({
  reducer: {
    toasts: toastsReducer,
  },
});
